/**
* DevExpress Dashboard (_dashboard-layout-node.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { floatFromModel, itemType } from '../../metadata/_base-metadata';
export let dashboardItem = { propertyName: 'dashboardItem', modelName: '@DashboardItem' };
export let orientation = { propertyName: 'orientation', modelName: '@Orientation', displayName: 'DashboardWebStringId.Chart.Orientation', defaultVal: 'Horizontal', simpleFormAdapterItem: 'textBoxEditor' };
export let layoutWeight = { propertyName: 'weight', modelName: '@Weight', defaultVal: 1, displayName: 'DashboardStringId.WeightCaption', simpleFormAdapterItem: 'numberBoxEditor', from: floatFromModel };
export let layoutItemsSerializable = { propertyName: 'childNodes', modelName: 'LayoutItems', displayName: 'DashboardWebStringId.Dashboard.LayoutItems', array: true };
export let layoutItemSerializationsInfo = [itemType, layoutWeight, orientation, layoutItemsSerializable, dashboardItem];
